import { IconRefresh } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import s from '../teacher-matching-progress.module.scss';

export const SearchAllTeachersOffer = ({ searchParams }) => {
	const navigate = useNavigate();

	const handleShowAll = () => {
		const params = new URLSearchParams();
		(searchParams?.instruments || []).forEach((id) => params.append('instruments', id));
		(searchParams?.days_type || []).forEach((day) => params.append('days_type', day));
		(searchParams?.time_of_day || []).forEach((time) => params.append('time_of_day', time));
		const query = params.toString();
		navigate(`/teachers${query ? `?${query}` : ''}`);
	};

	return (
		<div className={s.offerBlock}>
			<div className={s.offerInfo}>
				<div className={s.offerIcon}>
					<IconRefresh size={24} stroke={2} />
				</div>
				<div className={s.offerText}>
					<p className={s.offerTitle}>Не нашли подходящий вариант?</p>
					<p className={s.offerSubtitle}>Посмотрите всех преподавателей, подходящих под ваш запрос.</p>
				</div>
			</div>
			<button type="button" className={s.offerButton} onClick={handleShowAll}>
				Посмотреть все варианты
			</button>
		</div>
	);
};
